import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { DatePipe, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { UsersComponent } from './components/users/users.component';
import { EventsComponent } from './components/events/events.components';
import { SingleEventsComponent } from './components/singleEvent/single-event.component';
import { NewsComponent } from './components/news/news.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NgxDropzoneModule } from 'ngx-dropzone';

import {
  LucideAngularModule,
  Menu,
  ChevronLeftCircle,
  ChevronRightCircle,
  Users2,
} from 'lucide-angular';
import { CustomBreadcrumbComponent } from './components/common/custom-breadcrumb/custom-breadcrumb.component';
import { SingleNewsComponent } from './components/singleNews/single-news.component';
import { ResourcesComponent } from './components/resources-all/resources/resources.component';

import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { AuthInterceptorService } from './core/interceptors/http.interceptor';
import { MemberViewComponent } from './components/member-view/member-view.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { JudgmentsComponent } from './components/Judgments/judgments.component';
import { MediaComponent } from './components/media/media.component';
import { DashbordComponent } from './components/dashbord/dashbord.component';
import { NzCalendarModule } from 'ng-zorro-antd/calendar';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { ResourceVideoComponent } from './components/resources-all/resource-video/resource-video.component';
import { ResourceArticleComponent } from './components/resources-all/resource-article/resource-article.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { SingleAlbumComponent } from './components/single-album/single-album.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { SingleResourceComponent } from './components/single-resource/single-resource.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ActsComponent } from './components/acts/acts.component';
import { JudgmentsOrdersComponent } from './components/judgments-orders/judgments-orders.component';
import { SearchJudgmentsComponent } from './components/search-judgments/search-judgments.component';
import { DownloadsComponent } from './components/downloads/downloads.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzAlertModule } from 'ng-zorro-antd/alert';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    UsersComponent,
    CustomBreadcrumbComponent,
    EventsComponent,
    SingleEventsComponent,
    NewsComponent,
    SingleNewsComponent,
    ResourcesComponent,
    MemberViewComponent,
    MyProfileComponent,
    JudgmentsComponent,
    MediaComponent,
    DashbordComponent,
    ResourceVideoComponent,
    ResourceArticleComponent,
    SingleAlbumComponent,
    SingleResourceComponent,
    ActsComponent,
    JudgmentsOrdersComponent,
    SearchJudgmentsComponent,
    DownloadsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IconsProviderModule,
    LucideAngularModule.pick({
      Menu,
      ChevronLeftCircle,
      ChevronRightCircle,
      Users2,
    }),
    NzLayoutModule,
    NzMenuModule,
    NzCardModule,
    NzButtonModule,
    NzBreadCrumbModule,
    NzTableModule,
    NzIconModule,
    NzInputModule,
    NzDividerModule,
    NzGridModule,
    NzDatePickerModule,
    NzDropDownModule,
    NzAvatarModule,
    NgxUiLoaderModule,
    NgxUiLoaderModule,
    NzCalendarModule,
    NzTabsModule,
    NzModalModule,
    NgxDropzoneModule,
    NzGridModule,
    NzInputModule,
    NzPaginationModule,
    NzPopconfirmModule,
    NzSelectModule,
    NzEmptyModule,
    NzPopoverModule,
    NzToolTipModule,
    NzRadioModule,
    NzAlertModule,
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    DatePipe,
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
